import React from 'react';
import styles from '../../index.module.sass';

const AgreementING = () => {
  return (
    <div className={styles.container}>
      <div className={styles.box}>
        <div className={styles.Titles}>
          <div className={styles.title}>Consultant </div>
          <div className={styles.subtitle}>Agreement</div>
        </div>
        <p className={styles.pharagraph}>
          I affirm that I am of legal age in the state in which I sign this Agreement. I understand
          that I will not be recognized as an Independent Consultant until the Company accepts the
          duly signed original Agreement.
        </p>
        <p className={styles.pharagraph}>
          I will not purchase products solely to qualify for commissions or bonuses. I agree to
          resell or personally consume at least 70% of all products I have purchased from the
          Company before placing a subsequent product order. Products reasonably consumed by me or
          my household and not acquired solely to meet compensation plan requirements shall be
          considered retail sales. Products considered sold under the 70% rule are not eligible for
          repurchase.
        </p>
        <p className={styles.pharagraph}>
          I have the right to cancel this Agreement at any time and for any reason by providing
          written notice to the Company. This business model does not contemplate that products or
          sales aids be held in inventory by the Independent Consultant for resale. The Company is
          aware that some repurchase laws extend to fees and other considerations paid, and to the
          extent such laws apply, the Company will comply with repurchase laws in Georgia, Idaho,
          Indiana, Louisiana, Maryland, Massachusetts, Mississippi, Montana, Nebraska, New Jersey,
          Oklahoma, Puerto Rico, South Carolina, South Dakota, Tennessee, Texas, Washington, and
          Wyoming. In addition, Consultants in Montana who terminate within 15 days shall be
          entitled to a 100% refund of all considerations paid for participation.
        </p>
        <p className={styles.pharagraph}>As an Independent Consultant, I am responsible for:</p>
        <ul>
          <li className={styles.list}>
            <span className={styles.span}>
              Providing training and motivation to my downline Consultants.
            </span>
          </li>
          <li className={styles.list}>
            <span className={styles.span}>
              Studying product literature and promoting retail sales.
            </span>
          </li>
          <li className={styles.list}>
            <span className={styles.span}>Representing the Company’s products honestly.</span>
          </li>
          <li className={styles.list}>
            <span className={styles.span}>Honoring the Company’s customer guarantees.</span>
          </li>
          <li className={styles.list}>
            <span className={styles.span}>Being professional, courteous, and respectful.</span>
          </li>
          <li className={styles.list}>
            <span className={styles.span}>
              Refraining from misrepresenting the Company’s Compensation Plan.
            </span>
          </li>
          <li className={styles.list}>
            <span className={styles.span}>
              Becoming familiar with and adhering to the Company’s Policies and Procedures and other
              official materials.
            </span>
          </li>
        </ul>
        <p className={styles.pharagraph}>
          I understand that Independent Consultants may not incur any debt, expense, or obligation
          on behalf of or for the Company under any circumstances.
        </p>
        <p className={styles.pharagraph}>
          I acknowledge that, as an Independent Consultant, I may not act as a spokesperson for the
          Company or its products in any media outlet or publication without prior written
          authorization. I will not create, print, publish, or distribute any literature or
          materials representing the Company or its products unless such materials originate from or
          are approved in writing by the Company.
        </p>
        <p className={styles.pharagraph}>
          I understand that, as an Independent Consultant, I have the following rights: (a) To
          solicit the sale of the Company’s products/services according to the Company’s
          Compensation Plan and Sales Policies, including but not limited to the Policies and
          Procedures; and (b) To sponsor other Independent Consultants in accordance with the
          Company’s Compensation Plan and Policies and Procedures.
        </p>
        <p className={styles.pharagraph}>
          I will not make any claims or guarantees of any kind, including but not limited to
          earnings or income related to the Compensation Plan or the Company’s products, beyond what
          is stated in official Company literature. I am not permitted to create my own literature,
          sales aids, or training materials without prior written consent from the Company.
        </p>
        <p className={styles.pharagraph}>
          I acknowledge that I am an independent contractor, not an agent, employee, or franchisee
          of the Company. I understand and agree that I will not be treated as an employee for
          federal or state tax purposes, nor for purposes of the Federal Unemployment Tax Act,
          Federal Insurance Contributions Act, Social Security laws, state unemployment laws, state
          employment security laws, or state workers' compensation laws. I agree to pay all
          applicable federal and state self-employment taxes, sales taxes, local taxes, and/or local
          licensing fees arising from my business activities under this Agreement.
        </p>
        <p className={styles.pharagraph}>
          I understand that acceptance of this Agreement does not constitute the sale of a franchise
          or security, that no exclusive territories are granted, and that no franchise fees have
          been paid or will be paid by me in connection with this Agreement.
        </p>
        <p className={styles.pharagraph}>
          The Company may, at its discretion, amend the Compensation Plan, the Policies and
          Procedures, and/or the terms of this Agreement. Amendments will be published in
          newsletters, on the Company website, via email, or made available to all Independent
          Consultants. I agree to comply with all such amendments. My continued operation of my
          business, acceptance of products, commissions, bonuses, or other payments from the Company
          constitutes my acceptance of all such amendments.
        </p>
        <p className={styles.pharagraph}>
          My business may not be sold, assigned, or transferred without the Company’s prior written
          approval.
        </p>
        <p className={styles.pharagraph}>
          <strong>Minimum Advertised Price (MAP) Policy</strong>
        </p>
        <p className={styles.pharagraph}>
          As an Independent Consultant, I acknowledge and accept that the General Public Price (also
          known as "Retail Price") published by Terramar shall be considered the Minimum Advertised
          Price (MAP) for all Company products.
        </p>
        <p className={styles.pharagraph}>
          For purposes of this policy, the General Public Price shall refer to prices published
          through any of Terramar’s official media, including but not limited to:
        </p>
        <ul>
          <li>The Offers Catalog</li>
          <li>The Monthly Magazine</li>
          <li>The official website: www.terramarbrandsusa.com</li>
          <li>Terramar USA’s official social media accounts</li>
        </ul>
        <p className={styles.pharagraph}>
          This price must be honored in any authorized public channel of sale, promotion, or
          communication, including but not limited to personal social media (Facebook, Instagram,
          TikTok, etc.), personal websites, independent printed catalogs, or any other direct or
          indirect sales medium accessible to the general public.
        </p>
        <p className={styles.pharagraph}>
          It is strictly prohibited to advertise, publish, or promote Terramar products below the
          MAP, or to use messaging or expressions implying lower prices, including but not limited
          to: "special price," "discount price," "ask for price," "exclusive offer," "send us a DM,"
          or any similar phrase suggesting unauthorized discounts.
        </p>
        <p className={styles.pharagraph}>
          The Company reserves the right to monitor and enforce this policy through any legal or
          contractual means available, in order to protect the integrity of its brand, pricing, and
          the commercial efforts of the entire Consultant network.
        </p>
        <p className={styles.pharagraph}>
          I have carefully reviewed the Company’s Compensation Plan and Policies and Procedures, and
          acknowledge that they are incorporated as part of this Agreement, including any amendments
          made by the Company from time to time. Any breach of the terms of this Agreement or the
          Company’s Policies and Procedures may, at the Company’s sole discretion, result in loss of
          commission and bonus payments, partial or total loss of my sales organization, or
          cancellation of this Agreement.
        </p>
        <p className={styles.pharagraph}>
          Violations of the MAP policy will result in the following consequences:
        </p>
        <ol>
          <li>First violation: formal written warning.</li>
          <li>
            immediate termination of this Agreement, with no right to compensation, commissions,
            bonuses, or other pending benefits.
          </li>
        </ol>
        <p className={styles.pharagraph}>
          This Agreement constitutes the entire understanding between the parties. No promise,
          representation, guarantee, or agreement shall be valid unless made in writing. If any
          provision is deemed invalid, all remaining provisions shall remain valid and enforceable.
        </p>
        <p className={styles.pharagraph}>
          The term of this Agreement is one year. This Agreement may be renewed annually on its
          anniversary date, unless cancelled or extended by the Company.
        </p>
        <p className={styles.pharagraph}>
          This Agreement shall be governed by the laws of the State of Florida. Any claim or dispute
          arising under this Agreement shall be subject to binding arbitration under the Commercial
          Rules of the American Arbitration Association, with arbitration held in Miami, Florida.
          Residents of Louisiana may elect to arbitrate in New Orleans, Louisiana.
        </p>
      </div>
    </div>
  );
};

export default AgreementING;
